module.exports = __webpack_public_path__ + "img/qq_icon.4d7cc3d.png";